module.exports = __webpack_public_path__ + "img/helvetia.2ec0102a.png";